module.exports = __webpack_public_path__ + "img/botella_azul_1.24faca79.png";